import React from 'react';
import { PreferencesProvider } from './preferences';

const ContextProvider = ({ children }) => <PreferencesProvider>{children}</PreferencesProvider>;

export default ContextProvider;
